module.exports = {
  logged_in_user: {
    avatar: '',
    type: '',
    company: {
      name: '',
      code: '',
      alias: '',
      avatar: '',
    },
    admin: false,
    username: '',
    fullName: '',
    role: '',
    permissions: [],
    staffLimit: 0,
    shopLimit: 0,
    tiktokShopLimit: undefined,
    plan: undefined,
    paymentType: undefined,
    createdDate : '',
  },
  token: null,
  isAdmin: false,
  stockApiURLs: {
    initData: "https://stock.salework.net/api/getInitData",
    addressCode: "https://stock.salework.net/api/getAddressCode",
    order: "https://stock.salework.net/api/order",
    customer: "https://stock.salework.net/api/customer",
    shipping: "https://stock.salework.net/api/3rd_logistic",
  },
  company_configurations: {},
  ai_configurations: [],
  configurations: null,
  settings: null,
  colorOrder: {
    'TẤT CẢ': '#28a745',
    'CHỜ XÁC NHẬN': '#6c757d',
    'ĐÃ GỬI HÀNG': '#d08b20',
    'ĐÃ ĐỐI SOÁT': '#6c757d',
    'KIỂM KÊ': '#6c757d',
    'CHỜ HÀNG': '#6c757d',
    'MỚI': '#007bff',
    'HẸN GIAO': '#007bff',
    'CHỜ ĐÓNG GÓI': '#17a2b8',
    'ĐANG ĐÓNG GÓI': '#17a2b8',
    'CHỜ GỬI HÀNG': '#17a2b8',
    'ĐANG GIAO': '#ffc107',
    'THÀNH CÔNG': '#28a745',
    'THẤT THU': '#dc3545',
    'HỦY': '#dc3545',
  },
  staging: false,
  cCode:'',
  conversationList : [],
  initData:{
    tags:[],
    message_templates:[],
    pages:[],
    employees:[],
    banned_words:[],
    user_config: {_id: "", pinned_conversations: [], created_at: ''}
  },
  media: null,
  channel: {
    FACEBOOK: {name : "Facebook", icon: 'Facebook.svg', unread: false},
    INSTAGRAM: {name : "Instagram", icon: 'Instagram.svg', unread: false},
    LAZADA:{ name: 'Lazada', icon: 'Lazada.svg', unread: false},
    SHOPEE:  {name :  "Shopee", icon: 'Shopee.svg', unread: false},
    TIKTOK:{ name: 'TikTok', icon: 'Tiktok.svg', unread: false},
    ZALO_OA:  {name :  "ZaloOA", icon: 'ZaloOA.svg', unread: false},
    LIVECHAT:  {name :  "LiveChat", icon: 'LiveChat.svg', unread: false},
  },
  conversation_type: {
    MESSAGE: "MESSAGE",
    COMMENT: "COMMENT"
  },
  channel_selected : '',
  account_selected : '',
  conversation_selected :{},
  local_data:{},
  vouchers : [],
  products : [],
}

// export default globalData;
